// MST
import { types } from 'mobx-state-tree';

// Helper
// import { withHelper_fileProps, withHelper_fileUserProps } from './file.helper';
import { withHelper_commonLoadingModel } from './common.helper';

// Types
const { model, maybeNull, optional, number, string, boolean, array } = types;

const UploadFile = optional(
  model('uploadFile').props({
    blobId: maybeNull(string),
    originalFileName: maybeNull(string),
    status: maybeNull(string),
    uploadDate: maybeNull(string),
    userFileBlobId: maybeNull(string),
    userOriginalFileName: maybeNull(string),
  }),
  {},
);

export const withHelper_preconditionFormModel = model('PreconditionForm').props({
  id: maybeNull(number),
  isDownloadFromPortal: maybeNull(boolean),
  isFilledbyAssessee: maybeNull(boolean),
  isGeneratefromCms: maybeNull(boolean),
  isGeneratefromPortal: maybeNull(boolean),
  name: maybeNull(string),
  description: maybeNull(string),
  uploadFiles: array(UploadFile),
  TTDAssesse: maybeNull(UploadFile),

  // For Front-End Only
  loading: withHelper_commonLoadingModel,
});

export const withHelper_preconditionFormCommentModel = model('PreconditionFormComment').props({
  id: maybeNull(number),
  profilePhoto: maybeNull(string),
  userName: maybeNull(string),
  roleName: maybeNull(string),
  date: maybeNull(string),
  comment: maybeNull(string),
  isChecked: maybeNull(optional(boolean, false)),

  // For-Front-End Only
  loading: withHelper_commonLoadingModel,
});

export const withHelper_preconditionDocHeaderFooterModel = model('DocHeaderFooter').props({
  id: maybeNull(number),
  position: maybeNull(string),
  imageUrl: maybeNull(string),
  text: maybeNull(string),
});

export const withHelper_preconditionDocTemplate = model('DocTemplate').props({
  body: maybeNull(string),
  topPage: maybeNull(string),
  topBody: maybeNull(string),
  bottomPage: maybeNull(string),
  bottomBody: maybeNull(string),
});

export const withHelper_preconditionPICList = model('PICList').props({
  picId: maybeNull(number),
  picName: maybeNull(string),
  picSchemaAreaName: maybeNull(string),
  picSchemaLevelName: maybeNull(string),
});

const question = optional(
  model('question').props({
    questionId: maybeNull(number),
    isQuestionTableBordered: maybeNull(boolean),
    isQuestionBordered: maybeNull(boolean),
    questionType: maybeNull(string),
    question: maybeNull(string),
    questionFileUrl: maybeNull(string),
  }),
  {},
);

const answerOption = optional(
  model('answerOption').props({
    id: maybeNull(string),
    answerOptionType: maybeNull(string),
    label: maybeNull(string),
    value: maybeNull(string),
    isSelected: maybeNull(boolean),
  }),
  {},
);

const answerFile = optional(
  model('answerFile').props({
    userFileTransactionId: maybeNull(number),
    userOriginalFileName: maybeNull(string),
    userFileBlobId: maybeNull(string),
  }),
  {},
);

const answer = optional(
  model('answer').props({
    answerCode: maybeNull(string),
    answerLayout: maybeNull(string),
    answerType: maybeNull(string),
    answerValue: maybeNull(string),
    answerFiles: array(answerFile),
    answerOption: array(answerOption),
  }),
  {},
);

const resultDetail = optional(
  model('resultDetail').props({
    question: maybeNull(question),
    answer: maybeNull(answer),
    headerId: maybeNull(number),
    id: maybeNull(number),
    childrenHeaderId: maybeNull(number),
    type: maybeNull(string),
  }),
  {},
);

const result = optional(
  model('result').props({
    kukNumber: maybeNull(string),
    resultDetail: array(resultDetail),
  }),
  {},
);

const headerChild = optional(
  model('headerChild').props({
    id: maybeNull(number),
    title: maybeNull(string),
    type: maybeNull(string),
  }),
  {},
);

const header = optional(
  model('header').props({
    id: maybeNull(number),
    title: maybeNull(string),
    type: maybeNull(string),
    children: array(headerChild),
  }),
  {},
);

const questionSet = optional(
  model('questionSet').props({
    questionSetId: maybeNull(number),
    questionSetLayout: maybeNull(string),
    instruction: maybeNull(string),
    header: array(header),
    result: array(result),
  }),
  {},
);

const competencyUnit = optional(
  model('competencyUnit').props({
    competencyUnitId: maybeNull(number),
    competencyUnitCode: maybeNull(string),
    competencyUnitTitle: maybeNull(string),
    competencyUnitName: maybeNull(string),
    questionSets: array(questionSet),
  }),
  {},
);

const competencyUnits = optional(
  model('competencyUnits').props({
    competencyUnits: array(competencyUnit),
  }),
  {},
);

export const withHelper_preconditionDocDetailAssessment = model('DetailAssessment').props({
  topFile: maybeNull(string),
  bottomFile: maybeNull(string),
  selfAssessments: array(competencyUnits),
});

export const withHelper_preconditionConsentAssessment = model('ConsentAssessment').props({
  schemaCertifName: maybeNull(string),
  schemaCertifNumber: maybeNull(string),
  tukTypeName: maybeNull(string),
  assessorName: maybeNull(string),
  assesseeName: maybeNull(string),
  scheduleDateTime: maybeNull(string),
  tukPlaceName: maybeNull(string),
});

export const withHelper_preconditionImageIcons = model('ImageIcons').props({
  iconChecked: maybeNull(string),
  iconNotChecked: maybeNull(string),
});

const answerSheet = model('answersheet').props({
  answerName: maybeNull(string),
  is_K: maybeNull(boolean),
  is_BK: maybeNull(boolean),
});

export const withHelper_preconditionAnswerSheets = model('AnswerSheets').props({
  answerSheets: array(answerSheet),
});
